import styles from "./Cart.module.css";
import Header from "./Header";
import Footer from "./Footer";
import Config from "./Config";
import { useEffect, useRef, useState } from "react";
import { useCart } from "./CartContext";
import { UseClearAgent } from "../manager/SearchParam";
import { useNavigate } from "react-router-dom";
import {useRefAgent} from "../hooks/useRefAgent";
import {usePincodeSearch} from "../hooks/usePincodeFinder";
import {useShippingFinder} from "../hooks/useShippingFinder";


function Cart() {
  const [OrderId, setOrderId] = useState(false);
  const [Products, setProducts] = useState(false);
  const {Ref, Agent, RefreshAgent} = useRefAgent();
  const [CartEmpty, setCartEmpty] = useState(false);
  const [ButtonPress, setButtonPress] = useState(null);
  const [ItemRemove, setItemRemove] = useState(null);
  const [Refresh, setRefresh] = useState(true);
  const [Loading, setLoading] = useState(true);
  const [Fetch, setFetch] = useState(false);
  const [OrderStatus, setOrderStatus] = useState(1);
  const [Shipping, setShipping] = useState(0);
  const {addItems} = useCart();
  const clearAgent = UseClearAgent();
  const [Pin, setPin] = useState("");
  const [ExPin, setExPin] = useState("");
  const [cartWeight, setCartWeight] = useState(null);
  const [cartDimensions, setCartDimentions] = useState({length:10, width:10, height:10});
  const [restricted, setRestricted] = useState(false);
  const [PinRefresh, setPinRefresh] = useState(true);
  const {PincodeFound, PincodeState, PincodeDistrict, PinSearchLoading} = usePincodeSearch(Pin);
  const {shippingOptions, shippingOptionsLoading} = useShippingFinder(Pin, cartWeight, restricted, cartDimensions);
  const [courierService, setCourierService] = useState(null);
  const {standard, premium, indiaPost} = shippingOptions || {};

  const cartID = crypto.randomUUID();
  const [Cart, setCart] = useState(localStorage.getItem("cart")?JSON.parse(localStorage.getItem("cart")) : {id: cartID, items: []});
  
  const [updatePinMessage, setUpdatePinMessage] = useState("Please Enter your Pincode to check availability!");
  const [Message, setMessage] = useState(false);
  let DeliveryCharge = 100;
  const navigate = useNavigate();
  const messageBox = useRef(null);
  const sectionShipping = useRef(null);
  const formName = useRef(null);
  const formEmail = useRef(null);
  const formAddress = useRef(null);
  const formPincode = useRef(null);
  const formPhone = useRef(null);
  const formCity = useRef(null);
  const formState = useRef(null);
  const formDistrict = useRef(null);
  const defaultAddress = {
    name: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    tel: ""
  };
  const [Address, setAddress] = useState(()=>{
    const saved = localStorage.getItem("addressDraft");
    return saved?JSON.parse(saved):defaultAddress;
  });
  
  if(Agent) {
    DeliveryCharge = 0;
    
  };
  const meta = document.querySelector('meta[name="description"]');
  if(meta) {
    meta.setAttribute("content", "View items in your cart");
  }
  document.title = "My-cart | "+Config.siteName;

  
  const filterProducts = Products&&Products.length>0?Products.filter(product=>product.availability === 1):[];
  const ProductPrice = filterProducts&&filterProducts.length>0?filterProducts.map(product=>{
    const MRP_V = product.MRP*product.qty;
    const discount_NV = Ref || Agent?0:(product.MRP-product.price)*product.qty;
    const discount_SP = Ref&&!Agent?(product.MRP-product.agent) / (product.MRP/100):0;
    const discount_SV = Ref&&!Agent?(product.MRP-product.agent)*product.qty:0;
    const discount_AP = Agent?(product.MRP-product.agent) / (product.MRP/100):0;
    const discount_AV = Agent?(product.MRP-product.agent)*product.qty:0;
    const dcode = Ref?Ref.code:false;
    const saved_V = discount_NV+discount_AV+discount_SV;
    const total_V = MRP_V-saved_V;
    const image = product.image;
    
    return {
      productId: product.productId,
      variantId: product.variantId,
      title: product.title,
      image: image,
      qty: product.qty,
      stock: product.stock,
      unit: product.unit,
      MRP: product.MRP,
      price: product.price,
      availability: product.availability,
      restricted: product.restricted,
      QXPrice: MRP_V,
      weight: product.weight,
      dimensions: product.dimensions,
      discountNV: discount_NV,
      discountSP: discount_SP,
      discountSV: discount_SV,
      savedV: saved_V,
      discountAP: discount_AP,
      discountAV: discount_AV,
      code: dcode,
      totalV: total_V
    };
  }):false;
  const ProductList = Products&&Products.length>0?Products.map(product=>{
    const MRP_V = product.MRP*product.qty;
    const discount_NV = Ref || Agent?0:(product.MRP-product.price)*product.qty;
    const discount_SP = Ref&&!Agent?(product.MRP-product.agent) / (product.MRP/100):0;
    const discount_SV = Ref&&!Agent?(product.MRP-product.agent)*product.qty:0;
    const discount_AP = Agent?(product.MRP-product.agent) / (product.MRP/100):0;
    const discount_AV = Agent?(product.MRP-product.agent)*product.qty:0;
    const dcode = Ref?Ref.code:false;
    const saved_V = discount_NV+discount_AV+discount_SV;
    const total_V = MRP_V-saved_V;
    const image = product.image;
    const availability = product.availability;
    if(availability === 1) {
      return {
        productId: product.productId,
        variantId: product.variantId,
        title: product.title,
        image: image,
        qty: product.qty,
        stock: product.stock,
        unit: product.unit,
        MRP: product.MRP,
        price: product.price,
        availability: product.availability,
        restricted: product.restricted,
        QXPrice: MRP_V,
        weight: product.weight,
        dimensions: product.dimensions,
        discountNV: discount_NV,
        discountSP: discount_SP,
        discountSV: discount_SV,
        savedV: saved_V,
        discountAP: discount_AP,
        discountAV: discount_AV,
        code: dcode,
        totalV: total_V
      };
    }
  else{
    return {
        productId: product.productId,
        variantId: product.variantId,
        title: product.title,
        image: image,
        qty: product.qty,
        stock: 0,
        unit: product.unit,
        MRP: 0,
        price: 0,
        availability: product.availability,
        restricted: product.restricted,
        QXPrice: 0,
        weight: product.weight,
        dimensions: product.dimensions,
        discountNV: 0,
        discountSP: 0,
        discountSV: 0,
        savedV: 0,
        discountAP: 0,
        discountAV: 0,
        code: dcode,
        totalV: 0
      };
  }
  }):false;
  let TotalWeight = ProductPrice?ProductPrice.reduce((sum, item)=>sum+(item.weight*item.qty), 0):false;
  TotalWeight = TotalWeight?TotalWeight:0;
  
  if(!Agent) {
    DeliveryCharge = courierService?courierService.price:0;
  }

  const ActualPrice = (ProductPrice?ProductPrice.reduce((sum,item)=>sum+item.QXPrice,0):0).toFixed(2);
  const TotalPrice = (ProductPrice?ProductPrice.reduce((sum, item)=>sum+item.totalV, 0):0);
  const DiscountedSV = ProductPrice?ProductPrice.reduce((sum,item)=>sum+item.discountSV,0).toFixed(2):0;
  const DiscountedAV = ProductPrice?ProductPrice.reduce((sum,item)=>sum+item.discountAV,0).toFixed(2):0;
  const SavedTV = ProductPrice?ProductPrice.reduce((sum,item)=>sum+item.savedV,0).toFixed(2):0;
  const [TotalPrice_whole, TotalPrice_decimal] = TotalPrice.toFixed(2).split(".");
  if(Agent && TotalPrice<Config.minCartValue) {
    DeliveryCharge = Config.agentDeliveryCharge;
  }
  const TotalPlusDelivery = TotalPrice+DeliveryCharge;
  const [TotalPlusDelivery_whole, TotalPlusDelivery_decimal] = TotalPlusDelivery.toFixed(2).split(".");

  const placeOrder = async () =>{
    const Alert = [];
    if(Address.pincode?.length===0) {
      Alert.push("Pincode required");
      formPincode.current?.classList.add(styles.required);
    }
    else formPincode.current?.classList.remove(styles.required);

    if(Address.name?.trim().length===0) {
      Alert.push("Name required");
      formName.current?.classList.add(styles.required);
    }
    else formName.current?.classList.remove(styles.required);

    if(Address.email?.length===0) {
      Alert.push("Email required");
      formEmail.current?.classList.add(styles.required);
    }
    else formEmail.current?.classList.remove(styles.required);

    if(Address.address1?.length===0) {
      Alert.push("Address required");
      formAddress.current?.classList.add(styles.required);
    }
    else formAddress.current?.classList.remove(styles.required);

    if(Address.tel?.length===0) {
      Alert.push("Phone number required");
      formPhone.current?.classList.add(styles.required);
    }
    else formPhone.current?.classList.remove(styles.required);

    if(Address.city?.length===0) {
      Alert.push("City/Town/Village name required");
      formCity.current?.classList.add(styles.required);
    }
    else formCity.current?.classList.remove(styles.required);

    if(Address.district?.length===0) {
      Alert.push("District required");
      formDistrict.current?.classList.add(styles.required);
    }
    else formDistrict.current?.classList.remove(styles.required);

    if(Address.state?.length===0) {
      Alert.push("State required");
      formState.current?.classList.add(styles.required);
    }
    else formState.current?.classList.remove(styles.required);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const checkEmail = regex.test(Address.email);
      if(!checkEmail) {
        Alert.push("Valid email required");
        formEmail.current?.classList.add(styles.required);
      }
    if(Address.tel?.length!==10) {
      Alert.push("Valid Phone number required");
      formPhone.current?.classList.add(styles.required);
    }
    if(!Agent) {
      if(!shippingOptions) {
        Alert.push("Shipping not available for selected pincode");
      }
      if(!courierService) {
        if(shippingOptions) {
          Alert.push("Please choose a delivery service");
        }
      }
    }

    if(Alert.length===0 && OrderId) {
      localStorage.setItem("addressDraft", JSON.stringify(Address));
      setFetch(true);
      await setOrder();
      setFetch(false);
    }
    else{
      Alert.push(Math.random());
      setMessage(Alert);
    }
  }
  const setOrder = async ()=>{
    const orderInfo = {
      orderId: OrderId,
      email: Address.email,
      phone: Address.tel,
      referrer: Agent?"Agent":Ref?"Referrer":"",
      refCode: Agent?.code || Ref?.code || "",
      subtotal: ActualPrice,
      shippingCost: !Agent ? courierService.price : DeliveryCharge,
      tax: 0,
      discount: SavedTV,
      total: TotalPrice,
      shippingOptions: !Agent ? Object.values(shippingOptions) : [],
      courierId: !Agent ? courierService.id : ""
    };
    const user = {};
    const items = Cart.items;
    const address = Address;

    try{
      const res = await fetch(Config.NodePath+"/api/my-cart/order/new", {
        credentials: "include",
        method: "POST",
        headers: {"Content-Type" : "application/json"},
        body: JSON.stringify({
          orderInfo: orderInfo,
          user: user,
          items: items,
          address: address
        })
      });
      if(res.ok) {
        const data = await res.json();
        if(data.message) {
          setMessage([data.message, Math.random()]);
        }
        if(data.refresh) {
          addItems(data.cart);
          setRefresh(true);
        }
        if(data.orderId) {
          localStorage.setItem("cart", JSON.stringify({id: Cart?Cart.id:cartID, items:[]}));
          navigate("/orders/"+data.orderId);
        }
      }
    }
    catch(err) {
      console.log(err);
    }
    
  }

  const addCart = (vid)=>{
    setButtonPress(vid);
    if(!Cart) return;
    setCart(prev=>({
      ...prev,
      items: prev.items.map(item=>{
        return item.vid === vid && item.qty < Config.maxItemsQty ? {...item, qty: item.qty + 1} : item
      })
    }));
  }

  const removeCart = async (vid,x)=>{
    if(!Cart) return;
    if(x===0) {
      setItemRemove(vid);
      setCart(prev=>({
        ...prev,
        items: prev.items.filter(item=>item.vid !== vid)
      }))
    }
    else {
      setButtonPress(vid);
      setCart(prev=>({
        ...prev,
        items: prev.items.map(item=>{
          return item.vid === vid && item.qty > 1 ? {...item, qty: item.qty - 1} : item;
        })
      }));
    }
  }

  const refreshAgent = (x) =>{
    const cancelAgent = document.getElementById("cancelAgent");
    if(cancelAgent) {
      if(x===0) cancelAgent.classList.add(styles.open);
      if(x===2) cancelAgent.classList.remove(styles.open);
      if(x===1) {
        clearAgent();
        RefreshAgent();
      }
    }
    
  }

  useEffect(()=>{
    const filterProductRestriction = Products&&Products.length>0?Products.filter(product=>product.availability === 1):[];
    const checkRestriction = filterProductRestriction.filter(product=>product.restricted === true);
    if(checkRestriction.length>=1) {
      setRestricted(true);
    }
    else{
      setRestricted(false);
    }
  }, [Products]);
  useEffect(()=>{
    if(!Cart) return;
    localStorage.setItem("cart", JSON.stringify(Cart));
    setRefresh(true);
  }, [Cart]);

  useEffect(()=>{
    const pin = ExPin;
    if(pin.length!==6 || pin === Pin || Agent) return;
    setPin(pin);
  }, [ExPin, Pin, Agent]);

  useEffect(()=>{
    
    if(TotalWeight>0 && OrderStatus === 2)
      {
      setCartWeight(TotalWeight);
      }
  }, [TotalWeight, OrderStatus]);

  useEffect(()=>{
    if(Pin.length!==6) return;
    setShipping(0);
    setUpdatePinMessage("checking...");
    if(PinSearchLoading) return;
    if(PincodeFound) {
      setAddress(prev=>({
        ...prev,
        state: PincodeState,
        district: PincodeDistrict,
        pincode: Pin
      }));
      sessionStorage.setItem("state", PincodeState);
    }
    
    if(OrderStatus!== 2 || shippingOptionsLoading) return;
    if(shippingOptions) {
      if(standard || premium) {
        if(standard) setCourierService(standard);
        else setCourierService(premium);
      }
      setShipping(1);
      setUpdatePinMessage("Shipping available for the pincode");
    }
    else{
      setCourierService(null);
      setShipping(2);
      setUpdatePinMessage("Shipping not available for the pincode");
    }
  }, [PincodeFound, PincodeDistrict, PincodeState, PinSearchLoading, Agent, Pin, shippingOptions, standard, premium, OrderStatus, shippingOptionsLoading]);

  useEffect(()=>{
    if(PincodeFound) localStorage.setItem("addressDraft", JSON.stringify(Address));
  }, [Address, PincodeFound]);
  
  useEffect(()=>{
    const section = ()=>{
      if(OrderStatus===2) {
        if(Address.pincode!=="" && PinRefresh) {
          setExPin(Address.pincode);
          setPinRefresh(false);
        }
        sectionShipping.current?.scrollIntoView({behavior: "smooth"});
      }
    }
    section();
  }, [OrderStatus, Address.pincode, PinRefresh]);

  useEffect(()=>{
    if(Message) {
      messageBox.current.classList.add(styles.show);
      const msg = setTimeout(()=>{
        messageBox.current.classList.remove(styles.show);
      }, 2500);
      return ()=> clearTimeout(msg);
    }
  }, [Message]);

  useEffect(()=>{
      const loading = document.getElementById("loading");
      if(Loading) {
        return loading.classList.add(styles.incomplete);
      }
      loading.classList.remove(styles.incomplete);
    }, [Loading]);
    useEffect(()=>{
      const loading = document.getElementById("loading");
      if(!Products) {
        return loading.classList.remove(styles.complete);
      }
      loading.classList.add(styles.complete);
  
    },[Products]);

  const handleChange = (e) =>{
    const {name, value} = e.target;
    if(Agent && name!=="pincode" && name!=="city" && name!=="district" && name!=="state") {
      setAddress(prev=>({...prev, [name]:value}));
    }
    if(!Agent) {
      setAddress(prev=>({...prev, [name]:value}));
    }
  }
  const saveDraft=(e)=>{
    const {name, value} = e.target;
    localStorage.setItem("addressDraft", JSON.stringify(Address));
    if(name==="pincode" && value.length===6 && value!==Pin) {
      setPinRefresh(true);
    }
    if(value?.length>0) {
      e.target.classList.remove(styles.required);
    }
    else if(name!=="address2") e.target.classList.add(styles.required);
    
    if(name==="pincode" && value?.length!==6) {
      e.target.classList.add(styles.required);
    }
    if(name==="email") {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const check = regex.test(e.target.value);
      if(!check) {
        e.target.classList.add(styles.required);
      }
    }
    if(name==="tel" && (!Number(value) || value?.length!==10)) {
      e.target.classList.add(styles.required);
    }
  };
  const handlePincode = (e)=>{
    const pincode = e.target.value.replace(/\D/g, ""); 
    setExPin(pincode.slice(0,6));
  }
  

  const updatePin = () =>{
    let pin = Pin;
    const checkNumber = /^\d+$/.test(pin);
    if(checkNumber && pin.length===6) {
    }
    else{
      alert("Please Enter a valid Pincode!");
    }
  }

  useEffect(()=>{
    if(Agent) {
      setShipping(1);
      setAddress(prev=>(
        {
          ...prev,
          pincode: Agent.pincode,
          city: Agent.location,
          district: Agent.district,
          state: Agent.state
        }));
    }
  },[Agent]);
  useEffect(()=>{
    const Lcart = localStorage.getItem("cart");
    if(!Lcart) return;
    const getCart = async ()=>{
      try{
        const res = await fetch(Config.NodePath+"/api/my-cart", {
          credentials: "include",
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({cart: JSON.parse(Lcart)})
        });
        if(res.ok) {
          const data = await res.json();
          if(data) {
            if(data.items?.length>0) {
              setProducts(data.items);
              setOrderId(data.orderId);
              setCartDimentions(data.box);
              setLoading(false);
              setButtonPress(null);
            }
            else {
              setProducts([]);
              setCartEmpty(true);
              setLoading(false);
              setButtonPress(null);
            }
          }
        }
      }
      catch(err) {
        console.log(err);
      }
    }
  if(Refresh) {
    getCart();
    setRefresh(false);
  }
  },[Refresh]);
  const CartTable = ProductList?ProductList.map((item, index)=>{
    return (
      <div key={index} className={`${styles.order} ${styles.itemTile} ${ButtonPress===item.variantId?styles.buttonPress:""} ${ItemRemove===item.variantId?styles.itemRemoved:""}`}>
        <div className={styles.item}>
          <div className={styles.title}><a href={`/product/${item.productId}?variant=${item.variantId}`} title="Visit Product page" >{`${item.title} - ${item.unit}`}</a></div>
        </div>
        <div className={styles.cover}>
          <div className={styles.thumbnail}><img src={item.image} alt="thumbnail" /></div>
          <div className={styles.price_cover}>
            <div className={styles.price}>
              <span className={styles.price_text}>MRP </span>
              <span className={styles.price_value}>{Number(item.MRP || 0).toFixed(2)}</span>
            </div>
            <div className={styles.price}>
              <span className={styles.price_text}>Quantity X Price </span>
              <span className={styles.price_value}>{Number(item.QXPrice || 0).toFixed(2)}</span>
            </div>
            <div className={styles.price}>
              <span className={styles.price_text}>{item.discountNP?item.discountNV+"% off ":""}Discount </span>
              <span className={styles.price_value}>-{Number(item.discountNV || 0).toFixed(2)}</span>
            </div>
            {item.code&&!Agent?(
            <div className={styles.price}>
              <span className={styles.price_text}><span className={styles.highlight}>Code Applied: {item.code} - {Math.floor(item.discountSP)}% off </span>Special Discount </span>
              <span className={styles.price_value}>-{Number(item.discountSV || 0).toFixed(2)}</span>
            </div>
            ):""}

            {Agent?(
            <div className={styles.price}>
              <span className={styles.price_text}><span className={styles.highlight}>Agent discount: {Math.floor(item.discountAP)}% off </span>Special Discount </span>
              <span className={styles.price_value}>-{Number(item.discountAV || 0).toFixed(2)}</span>
            </div>
            ):""}
            
            <div className={styles.total}>
              <span className={styles.total_text}>Sub Total</span>
              <span className={styles.total_value}>{Number(item.totalV || 0).toFixed(2)}</span>
            </div>
          </div>
        </div>
        <div className={styles.options}>
          <div className={styles.remove}>
            <button disabled={ButtonPress!==null?true:false} onClick={()=>removeCart(item.variantId,0)} title="Remove from My Cart">-</button> Remove Item
          </div>
          <div className={styles.qty}>
            {item.availability === 1 ? (
              <>
              <span className={styles.qty_text}>Quantity</span>
              <div className={styles.qty_value}>
                <button onClick={()=>removeCart(item.variantId,1)} disabled={item.qty<=1 || ButtonPress!==null?true:false}>-</button>
                <input id={"input"+item.productId} name={"input"+item.productId} type="text" readOnly value={item.qty} />
                <button onClick={()=>addCart(item.variantId)} disabled={item.qty>=Config.maxItemsQty || item.qty >= item.stock || ButtonPress!==null?true:false}>+</button>
              </div>
              </>
            ): "Out of stock"}
              
          </div>
        </div>
      </div>
    );
  }):(<div className={`${styles.order} ${styles.itemTile}`}>{!CartEmpty?"Checking...":(<>
  <span className={styles.emptyCart}>My-cart is empty</span>
  <span style={{textAlign:"center", padding:"5vh"}}><a className={styles.returnLink} href="/" title="home page">🡐 Back to home page</a></span>
  </>)}</div>);
  //End CartTable

  const DeliverySection = (
    <div className={`${styles.order} ${styles.orderDelivery}`}>
      <span>* Delivery</span>
      <span>{Agent&&DeliveryCharge===0?"Free 💚":Agent?`₹${DeliveryCharge}`:courierService&&courierService.price?Number(courierService.price || 0).toFixed(2):"not available"}</span>
    </div>
  );
  //End DeliverySection

  const shippingServices = (
    <>
    <div className={`${styles.order} ${styles.shippingServices} ${Shipping===0?styles.hide:""}`}>
      <div className={styles.courierTitle}>
        <div className={styles.options}></div>
        <div className={styles.name}>Delivery options</div>
        <div className={styles.price}>Price</div>
        <div className={styles.days}>Delivery Time</div>
      </div>
      {standard?(
        <div className={styles.courierInfo} onClick={()=>{setCourierService(standard)}}>
          <div className={styles.name}>
            <input name={standard.id} type="radio" readOnly={true} checked={courierService&&courierService.id === standard.id?true:false} />
            {standard.name} - Normal Delivery</div>
          <div className={styles.price}>₹{standard.price}</div>
          <div className={styles.days}>{standard.days} days</div>
        </div>
      ):""}
      {premium?(
        <div className={styles.courierInfo} onClick={()=>{setCourierService(premium)}}>
          <div className={styles.name}>
            <input name={premium.id} type="radio" readOnly={true} checked={courierService&&courierService.id === premium.id?true:false} />
            {premium.name} - Faster Delivery</div>
          <div className={styles.price}>₹{premium.price}</div>
          <div className={styles.days}>{premium.days} days</div>
        </div>
      ):""}
      {indiaPost?(
        <div className={styles.courierInfo} onClick={()=>{setCourierService(indiaPost)}}>
          <div className={styles.name}>
            <input name={indiaPost.id} type="radio" readOnly={true} checked={courierService&&courierService.id === indiaPost.id?true:false} />
            {indiaPost.name} - Normal Delivery</div>
          <div className={styles.price}>₹{indiaPost.price}</div>
          <div className={styles.days}>{indiaPost.days} days</div>
        </div>
      ):""}
    </div>
    </>
  );

  const ActualTotalSection = (
    <>
    <div className={`${styles.order} ${styles.orderActualTotal}`}>
      <div className={styles.cover}>
        <div className={styles.total_text}>Total:</div>
        <div className={styles.total_value}>
          <span className={styles.crossed}>{ActualPrice}</span>
        </div>
      </div>
      <div className={styles.cover}>
        <div className={styles.total_text}>You saved:</div>
        <div className={styles.total_value}>
          <span >{SavedTV}</span>
        </div>
      </div>
    </div>
    </>
  );

  const TotalSection = (
    <div className={`${styles.order} ${styles.orderTotal}`}>
      <div className={styles.total_text}>Total:</div>
      <div className={styles.total_value}>
        <span className={styles.rupee}>₹{TotalPrice_whole}.</span><span className={styles.paise}>{TotalPrice_decimal}</span>
      </div>
    </div>
  );
  //End TotalSection
  const TotalPlusDeliverySection = (
    <div className={`${styles.order} ${styles.orderTotal}`}>
      {!Agent && !shippingOptions?<div className={styles.total_text}>Delivery service unavailable</div>:(
        <>
        <div className={styles.total_text}>Total + Delivery:</div>
        <div className={styles.total_value}>
          <span className={styles.rupee}>₹{TotalPlusDelivery_whole}.</span><span className={styles.paise}>{TotalPlusDelivery_decimal}</span>
        </div>
        </>
      )}
      
    </div>
  );
  //End TotalPlusDeliverySection

  const ConditionSection = (
    <div className={`${styles.order} ${styles.orderNote}`}>
      * Delivery charges are calculated based on weight and location.
    </div>
  );
  //End ConditionSection

  const ReferrerSection = (
    <>
    {Ref&&!Agent&&Products&&Products.length>0?(<div className={`${styles.order} ${styles.orderDiscount}`}>
      <span>This item is recommended by <b>{Ref.title} {Ref.name}</b> . You will receive a special discount 
      and save a total of ₹{DiscountedSV} on this purchase.</span>
      
    </div>):""}
    {Agent&&Products&&Products.length>0?(<div className={`${styles.order} ${styles.orderDiscount}`}>
      <span>This item is recommended by <b>{Agent.title} {Agent.name}</b> . You will receive a special discount 
      and save a total of ₹{DiscountedAV} on this purchase.</span>
      
    </div>):""}
    </>
  );
  //End ReferrerSection

  const minCartValue = (
    <>
    {Agent&& TotalPrice<Config.minCartValue?(<div className={`${styles.order} ${styles.orderMinCartValue}`}>
      <span>Add ₹{Config.minCartValue-TotalPrice} more for free delivery. 🛒</span>
      
    </div>):""}
    </>
  );

  const NextSection = (
    <div className={`${styles.order} ${styles.orderPlacement}`}>
      <button onClick={()=>setOrderStatus(2)} disabled={OrderStatus!==1?true:false}>{OrderStatus!==1?"Done":"Continue"}</button>
    </div>
  );
  //End NextSection

  const StatusSection = (
    <div className={`${styles.order} ${styles.orderStatus}`}>
      <div className={styles.status}>
        <span>My cart</span>
        <span>Shipping info</span>
        <span>Place order</span>
      </div>
      <div className={styles.bar}>
        <div className={styles.barGreen} style={{flex: OrderStatus*0.33}}></div>
        
      </div>
    </div>
  );
  //End StatusSection
  const ShippingSection = (
    <div ref={sectionShipping} className={`${styles.order} ${styles.orderShipping}`}>
      <div id="Section2" className={styles.title}>Shipping Address</div>
      {Agent?"":(
        <div className={`${styles.pincodeCheck} ${Shipping===2?styles.red:""} ${Shipping===1?styles.green:""}`}>
          <div className={styles.input}>
            <input value={ExPin} onChange={handlePincode} className={styles.pincode} name="updatePin" id="updatePin" type="text" placeholder="Pincode" />
            <button onClick={updatePin}>Check</button>
          </div>
          <div className={`${styles.message} ${Shipping===2?styles.red:""} ${Shipping===1?styles.green:""}`}>
            {updatePinMessage}
          </div>
        </div>
      )}
      <div className={styles.form}>
        <div className={`hide ${Shipping!==1?styles.hide:""}`}></div>
        <div>
          <input className={styles.input} title="Name" ref={formName} onChange={handleChange} onBlur={saveDraft} value={Address.name} name="name" id="name" type="text" placeholder="Full Name" autoComplete="name" />
          <input className={styles.input} title="Email" ref={formEmail} onChange={handleChange} onBlur={saveDraft} value={Address.email} name="email" id="email" type="email" placeholder="Email" autoComplete="email"/>
        </div>
        <input className={styles.input} title="Address" ref={formAddress} onChange={handleChange} onBlur={saveDraft} value={Address.address1} name="address1" id="address1" type="text" placeholder="Address Line 1" autoComplete="address-line1"/>
        <div>
          <input className={styles.input} title="Address Line 2 / Landmark" onChange={handleChange} onBlur={saveDraft} value={Address.address2} name="address2" id="address2" type="text" placeholder="Address Line 2 / Landmark / Optional" autoComplete="address-line2"/>
          <input className={styles.input} title="Phone Number" ref={formPhone} onChange={handleChange} onBlur={saveDraft} value={Address.tel} name="tel" id="tel" type="text" placeholder="Phone Number" autoComplete="tel"/>
        </div>
        <div>
          <input className={styles.input} title="City/Town/Village" ref={formCity} readOnly={Agent?true:false} onChange={handleChange} onBlur={saveDraft} value={Address.city} name="city" id="city" type="text" placeholder="City / Town / Village" autoComplete="address-level2"/>
          <input className={styles.input} title="District" ref={formDistrict} readOnly={Agent?true:false} onChange={handleChange} onBlur={saveDraft} value={Address.district} name="district" id="district" type="text" placeholder="District"/>
        </div>
        <div>
          <input className={styles.input} title="State" ref={formState} readOnly={Agent?true:false} onChange={handleChange} onBlur={saveDraft} value={Address.state} name="state" id="state" type="text" placeholder="State" autoComplete="address-level1"/>
          <input className={styles.input} title="Pincode" ref={formPincode} readOnly={true} value={Address.pincode} name="pincode" id="pincode" type="readOnly" placeholder="Pincode"/>
        </div>
        
      </div>
      {!Agent?"":(
        <div className={styles.message}>
          <div id="cancelAgent" className={styles.confirmation}>
            <div>Wait - you'll lose a special discount worth ₹{DiscountedAV} plus free shipping. Continue?</div>
            <div><button onClick={()=>refreshAgent(1)}>Yes</button><button onClick={()=>refreshAgent(2)}>No</button></div>
            
          </div>
          Some fields can't be edited because you selected a local delivery agent. If you're outside the service area, click below to cancel the agent.
          <button onClick={()=>refreshAgent(0)}>Cancel Agent</button>
        </div>
      )}
    </div>
  );
  //End ShippingSection

  const PlaceOrderSection = (
    <div className={`${styles.order} ${styles.orderPlacement}`}>
      <button onClick={placeOrder} disabled={Fetch} >{Fetch?(<>Processing <span className={styles.spinner}></span></>):"Place Order Now"}</button>
    </div>
  );
  //End NextSection

  const LoadingPage = (
      <><div id="loading" className={`${styles.loading}`}><div className={styles.loader}></div></div></>
    );
  return(
    <>
    {<Header />}
    <div className={`${styles.fullWrapper}`}>
      {LoadingPage}
      <div className={styles.MessageWrapper}>
        <div ref={messageBox} className={styles.message}>
          {Array.isArray(Message)?Message.map((item,index)=>{if(index!==Message.length-1) return(<span key={index}>{item}</span>); else return null}):""}
        </div>
      </div>
      <div className={`${styles.order} ${styles.orderTitle}`}>Items in My-Cart</div>
      {CartTable}
      {Products&&Products.length>0?ReferrerSection:""}
      
      {Products&&Products.length>0&&ActualPrice>TotalPrice?ActualTotalSection:""}
      {Products&&Products.length>0?TotalSection:""}
      {Products&&Products.length>0?minCartValue:""}
      {ProductPrice&&ProductPrice.length>0?NextSection:""}
      {Products&&Products.length>0?StatusSection:""}
      {Products&&Products.length>0&&OrderStatus===2?ShippingSection:""}
      {Products&&Products.length>0&&OrderStatus===2&&!Agent&&shippingOptions?shippingServices:""}
      {Products&&Products.length>0&&OrderStatus===2&&(Pin || Agent)?DeliverySection:""}
      {Products&&Products.length>0&&OrderStatus===2&&(Pin || Agent)?TotalPlusDeliverySection:""}
      {Products&&Products.length>0&&OrderStatus===2?ConditionSection:""}
      {Products&&Products.length>0&&OrderStatus===2?PlaceOrderSection:""}
      {Products&&Products.length>0&&OrderStatus===2?StatusSection:""}
      
    </div>
    {<Footer />}
    </>
  );
}

export default Cart;